import { KrCard } from '@/common/card/KrCard';
import { DimTree } from '@/common/entityFramework/entityPerspective/support/DimTree';
import { ContentBox } from '@/common/layout/ContentBox';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { TreeUtils } from '@/common/utils/TreeUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box, FormControlLabel, Switch } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { AbvManAccrAdjBarChart } from './charts/AbvManAccrAdjBarChart';
import { AbvOpenPeriodDiscrepanciesGridChart } from './charts/AbvOpenPeriodDiscrepanciesGridChart';

export const AbvReconDashboard = () => {
  const periodicityToPeriodCodes = useRef();

  const [prodTree, setProdTree] = useState();

  const [prodIds, setProdIds] = useState();
  const [breakoutByProduct, setBreakoutByProduct] = useState(false);

  const rsrc = useRsrc();

  useEffect(() => {
    rsrc.data('gtn', 'RECON_DASHBOARD_FILTERS_DATA_PLUGIN').then((res) => {
      periodicityToPeriodCodes.current = res.periodicityToPeriodCodes;

      setProdTree(res.prodTree);
      const processed = TreeUtils.parseTree(res.prodTree).leafIds;
      setProdIds(processed);
    });
  }, []);

  if (!prodTree || !prodIds) return null;

  return (
    <ContentBox>
      {/* Title */}
      <Box sx={{ mb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
        <Title icon={fas.faChartLine} title="P/L vs BS Reconciliation Dashboard" />
        <FormControlLabel
          control={
            <Switch
              color="success"
              checked={breakoutByProduct}
              onChange={(e) => setBreakoutByProduct(e.target.checked)}
            />
          }
          label="Breakout by Product"
        />
      </Box>

      {/* Filters */}
      <Box sx={{ mb: 2, display: 'flex', gap: 2 }}>
        <DimTree
          displayName="Product"
          treeData={prodTree}
          selectedIds={prodIds}
          onFilterChange={(ids) => setProdIds(ids)}
        />
      </Box>

      <SpacerLayout>
        <Spacer vertical weights={[4, 5]}>
          <AbvOpenPeriodDiscrepanciesGridChart prodIds={prodIds} breakoutByProduct={breakoutByProduct} />

          <KrCard title="Manual Accrual Adjustments by Channel">
            <AbvManAccrAdjBarChart prodIds={prodIds} />
          </KrCard>
        </Spacer>
      </SpacerLayout>
    </ContentBox>
  );
};
